export default __webpack_public_path__ + "static/media/close.1eda540d.svg";